import { BoldIcon, ItalicIcon, UnderlineIcon } from 'canoe';
import React from 'react';

import { FormatButton } from './FormatButton';

export const MenuItems = () => (
  <>
    <FormatButton format="B" tooltip="Bold" shortcuts={['mod', 'B']} icon={BoldIcon} />
    <FormatButton format="Em" tooltip="Italic" shortcuts={['mod', 'I']} icon={ItalicIcon} />
    <FormatButton format="U" tooltip="Underline" shortcuts={['mod', 'U']} icon={UnderlineIcon} />
  </>
);
